export { default as ChatbotService } from './ChatbotService';
export { default as ConfigurationService } from './ConfigurationService';

export const API_URL_BASE = process.env.TCC_API_URL;
export const MODULE_NAME = process.env.MODULE_NAME;

export const get = async (endpoint, token) => {
    const options = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    };

    const request = await fetch(`${API_URL_BASE}/${endpoint}`, options);
    const result = await request.json();
    const { status } = request;

    return {
        result,
        status
    };
};

export const post = async (endpoint, data, token) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    };

    const request = await fetch(`${API_URL_BASE}/${endpoint}`, options);
    const result = await request.json();
    const { status } = request;

    return {
        result,
        status
    };
};
